
<button type="button" class="-m-2.5 p-2.5 text-normal lg:hidden" (click)="toggleModalEmitter()">
    <span class="sr-only">Open sidebar</span>
    <svg class="size-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
</button>
<div  #currentScope class="relative z-10" [ngClass]="{
'hidden': !show,
'block': show
}" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0"></div>
  <div class="fixed inset-0 overflow-hidden">
    <div class="absolute inset-0 overflow-hidden">
      <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16"
           [ngClass]="{
      'hidden': !show,
   }">
        <div class="pointer-events-auto bg-card w-screen max-w-md transform transition ease-in-out duration-500 sm:duration-700" [ngClass]="{
            'translate-x-0': show,
            'translate-x-full': !show
         }">
          <div class="ml-3 flex h-7 items-center">
<!--            <button type="button" (click)="toggleModalEmitter()" class="relative mt-5 rounded-md text-normal hover:text-normal focus:outline-none focus:ring-2 focus:ring-offset-2">-->
<!--              <span class="absolute -inset-2.5"></span>-->
<!--              <span class="sr-only">Close panel</span>-->
<!--              <svg class="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">-->
<!--                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />-->
<!--              </svg>-->
<!--            </button>-->
          </div>
          <div>
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
